import script from "./ConferencePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ConferencePage.vue?vue&type=script&setup=true&lang=js"

import "./ConferencePage.vue?vue&type=style&index=0&id=21c62095&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c62095"]])

export default __exports__